import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class TasksCountColumn extends Column {
    title = 'table.task-templates.tasksCompleted';
    property = 'tasksCountLabel';
    type: CellDisplay = CellDisplay.string;
    sortable = false;
}
